export const Movies: Record<string, string[]> = {
  EL: [
    'Ο Δημήτριος και οι Μονομάχοι',
    'Τρελός για Έρωτα',
    'Μαρία Μαγδαληνή',
    'Η Πρώτη Επαφή ενός Πρωτάρη',
    'Ο καθηγητής και ο τρελός',
    'Αλύγιστος/ Αλύγιστος: η λύτρωση',
    'Ο Υπέροχος Γκάτσμπυ',
    'Κατηγορω...!',
    'Να με φωνάζεις με τ` όνομά σου',
    'Κάτω από τον Ήλιο',
    'Το Πορτραίτοίτο: Η Αλλόκοτη Μάτια Της Ντάιαν Άρμπους',
    'Υποψία',
    'Όλα για την Εύα',
    'Όσο Υπάρχουν Ανθρωποι',
    'Οι Δρόμοι της Φωτιάς',
    'Κοκτέιλ',
    'Θέλημα Θεού',
    'Ζαμπρίσκι Πόιντ',
    'Αόρατη Κλωστή',
    'Έρωτας χωρίς τέλος',
    'Για την Αγάπη ενός Σκύλου',
    'Το Παρελθον',
    'Περηφάνια & Προκατάληψη',
    'Άνθρωποι και Ποντίκια',
    'Αμαρτωλό Ταξίδι',
    'Πριν τα Μεσάνυχτα',
    'Με Αγάπη, Σάιμον',
    'Έρωτας Δίχως Παρόν',
    'Μια Υπέροχη Ζωή',
    'Πρόγευμα στο Τίφανις',
    'Το Βαποράκι',
    'Ο Χιτών',
    'Πόλεμος και Ειρήνη',
    'Το Πέρασμα στην Ινδία',
    'Η Ζωή του Πι',
    'Ένα αστέρι γεννιέται',
    'Γλυκιά Ήβη: Η Μυστική Αδελφότητα',
    'Μαθήματα Σεξουαλικής Συμπεριφοράς',
    'Ο Μισσισσιππής Καίγεται',
    'Ο Νονός 2',
    'Μετά',
    'Η Μορφή του Νερού',
    'Η Βίβλος',
    'Ξυπόλητοι στο Πάρκο',
    'Το Πράσινο Βιβλίο',
    'Μολιέρος',
    'Η Έξοδος: Θεοί και Βασιλιάδες',
    'Ο Πειρασμός Του Πάθους',
    'Υπηρέτριες',
    'Μαίρη η Βασίλισσα της Σκωτίας',
    'Φάργκο',
    'Το μεγάλο Σορτάρισμα',
    'Τα Φτερά του Ερωτα',
    'Μεγάλε μου Έρωτα',
    'Νωε',
    'Οργισμένο Είδωλο',
    'Το βιβλιοπωλείο της κυρίας Γκριν',
    'Φαβορί Για Τον Τίτλο',
    'Μια Αγάπη Γεννιέται',
    'Οι 12 Ενορκοι',
    'Πριν Το Ξημέρωμα',
    'Αβάνα Μπλούζ',
    'Σκυλίσια Μέρα',
    'Οι Ρατσιστες Του Νοτου',
    'Εγώ, ο Ντάνιελ Μπλέικ',
    'ΠΡΙΝ ΤΟ ΞΗΜΕΡΩΜΑ & ΠΡΙΝ ΤΟ ΗΛΙΟΒΑΣΊΛΕΜΑ',
    'Η πιο μεγάλη απάτη',
    'Η Θεωρία των Πάντων',
    'Βικτώρια & Αμπντούλ',
    'Δύση ηλίου',
    'Μποέμικη ψυχή',
    'Ο Θάνατος του Ιερού Ελαφιού',
    'Η Αποπλάνηση',
    'Τελευταία Έξοδος: Ρίτα Χέιγουωρθ',
    'Η Λίστα του Σίντλερ',
    'Απέραντο Γαλάζιο',
    'Το ένστικτο της επιβίωσης',
    'Γολγοθάς',
    'Στην πύλη της αιωνιότητας',
    'Καζαμπλάνκα',
    'Το Χάσμα',
    'Το Διάστημα Ανάμεσά μας',
    'Το Πέρασμα: Μέρος 1',
    'Κάποιες Γυναίκες',
    'Απροσδόκητος Έρωτας',
    'Κάθε μέρα, μια άλλη μέρα',
    'Ο Δικηγόρος',
    'Η ενοχή του Κένεντι',
    'Συνέβη το Καλοκαίρι',
    'Ο Ζωολογικός μας Κήπος',
    'Το Χρώμα του Χρήματος',
    'Τζέρι Λι Λιούις: Ο Θρύλος του Ροκ',
    'Εμφυτο Ελάττωμα',
    'Ο Δικαστής',
    'Μήπως είσαι ο τύπος μου;',
    'Ντικ Τρεησυ',
    'Βασιλιάς Αρθούρος: Ο Θρύλος του Σπαθιού',
    'Ο Λογιστής',
    'Σνόουντεν',
    'Η κιβωτός των ανθρώπων',
    'Η Απίστευτη Ιστορία του Μπέντζαμιν Μπάτον',
    'Ο Νόμος της νύχτας',
    'Ακίνητες Ζωές',
    'Έως το τέλος',
    'Ανθισμένες Μανόλιες',
    'Ευτυχισμένος Όσκαρ',
    'Μπάρρυ Λύντον',
    'Ο Λώρενς της Αραβίας',
    'Κοινωνικά Σκάνδαλα',
    'Ο Άνθρωπος από το Λος Άντζελες',
    'Τζεημς Μποντ 007 - Πεθανε Μια Αλλη Μερα',
    'Τζέιμς Μποντ 007: Ζήσε κι Άσε τους Άλλους να Πεθάνουν',
    'Φάρσα Ή Κέρασμα',
    'Πυροσβεστικός Σταθμός 49',
    'Ο Παραχαράκτης',
    'Ληστεία ...αλά Ιταλικά',
    'Ένταση',
    'Τα Καλά Παιδιά',
    '9/11',
    'Οι Αναλώσιμοι, Οι Αναλώσιμοι 2, Οι Αναλώσιμοι 3',
    'Ελεύθερος Σκοπευτής: Επιχείρηση Διάβολος',
    'Ο Όλυμπος Έπεσε',
    'Εκδικητής',
    'Σχέδιο απόδρασης',
    'Ο Ταχυδακτυλουργός',
    'Καρατε Κιντ Η Νεα Γενια',
    'Το Υποβρύχιο',
    'Παράνομοι',
    'Ο Μαύρος Πύργος',
    'Σταρ Τρεκ: Η Εξέγερση',
    'Το Σινικό Τείχος',
    'Το Φάντασμα στο Κέλυφος',
    'Ο Άρχοντας Των Δαχτυλιδιών: Η Συντροφιά Του Δαχτυλιδιού',
    'Η Τιτανομαχία',
    'Αντ-Μαν',
    'Γκοτζίλα',
    'Κάτω από το Δέρμα',
    'Οι άρχοντες του σκότους',
    'Εξολοθρευτής 3 - Η εξέγερση των Μηχανών',
    'Ο Ήρωας της Κόλασης',
    'Σόφι',
    'Η μάχη των καταραμένων',
    'Οι Άνδρες με τα Μαύρα',
    'Η Εισβολή των Ρομπότ',
    'Ο εκλεκτός της νύχτας',
    'Στην σκιά της διαφθοράς',
    '12 Δυνατοί',
    'Ο Υποκινητής: Άκρως επικίνδυνοι καταζητούμενοι',
    'Η Απόδραση',
    'Χαιλαντερ - Ο Αθανατος',
    'ΤΡΟΜΟΣ ΣΤΟΝ ΒΥΘΟ',
    'Στην αγκαλιά του φιδιού',
    'Η Καταστροφή Του Λονδίνου',
    'Απόρρητος φάκελος ιπκρες',
    'Εκτελεστής Χωρίς Οίκτο',
    'Γόμορρα',
    'Βήματα στο Άγνωστο',
    'Η Εκτελέστρια',
    'Το τετράγωνο',
    'Ρομπέν των Δασών',
    'Η ΑΓΑΠΗ ΕΙΝΑΙ ΠΑΡΑΞΕΝΗ',
    'Ματωμένος Γάμος',
    'Με την πρώτη ματιά',
    '25η Ώρα',
    'Παζολίνι',
    'Όμορφη Νιότη',
    'Το σιωπηλό βουνό',
    'Οι Ναυαγοί',
    'Το δικαστήριο',
    '33 Ψυχές',
    'Η Ληστεία θέλει Στύλ',
    'Μαμάδες σε Δράση',
    'Αναρχία',
    'Καταφύγιο',
    'Ήρωες της σκόνης',
    'Τζακ',
    'Παράδεισος του Ερωτα',
    'Πολιτική μας Είναι η Κρίση',
    'Η Διάρρηξη',
    '1001 Γραμμάρια',
    'Άμλετ',
    'Αμερικάνικο Ειδύλλιο',
    'Το πρώτο ραντεβού',
    'Φονική Καταιγίδα',
    'Ο Κος Τίποτα',
    'Η Σιωπή των Αμνών',
    'Ο Φαροφύλακας',
    'Η Εξαφανισμένη',
    'Ο Δρόμος Του Χρήματος',
    'Εξουσία Πυρός',
    'Ο Ένοικος',
    'Ανθρωποκυνηγητό',
    'Απαγωγή',
    'Ο Χιονάνθρωπος',
    'Το Κορίτσι του Τρένου',
    'Μια αληθινή ιστορία',
    'Λος Άντζελες Εμπιστευτικό',
    'Το Κάλεσμα',
    'Κώδικας Ντα Βίντσι',
    'Το Σύνδρομο του Βερολίνου',
    'Το Χέρι στην Κούνια',
    'Επαφή',
    'Δημόσιος Κίνδυνος',
    'Σκοτεινό Χωριό',
    'Νύχτες στο Μανχάταν',
    'Η Φίρμα',
    'Νυκτόβια πλάσματα',
    'Λουτρό Αίματος',
    'Καλύτερα ο διάβολος που ξέρεις',
    'Το δάσος',
    'Ο Συγγραφέας',
    'Πάση Θυσία',
    'Το Ασυλο',
    'Κάθαρση: Η Αρχή',
    'Αντιμέτωπος Με Το Παρελθόν',
    'Αμέρικα',
    'Το Μυστικό του Τάφου',
    'Τυφλό Κτύπημα',
    '´Αστοχη Βολή',
    'Φονικό Όπλο',
    'Από το σούρουπο ως την αυγή',
    'Μαύρο Ψωμί',
    'Το κορίτσι με το τατουάζ',
    'Κόναν ο Βάρβαρος',
    'Το Τέλειο Χτύπημα',
    'Ο Τελευταίος Πρόσκοπος',
    'Παιχνίδια Ολέθρου',
    'Τζέιμς Μποντ Πράκτωρ 007: Επιχείρηση Κινούμενος Στόχος',
    'Το ημερολόγιο της Σάρα',
    'Επίδοξος μαφιόζος',
    'Σχέδιο Εγκλήματος',
    'Οι Τέσσερις Πολεμιστές',
    'Χωρίς διέξοδο',
    'Ασυγκράτητη οργή',
    'Αλλαγή Πορείας',
    'Δύο Καπνισμένες Κάννες',
    'Έκρηξη Αδρεναλίνης',
    'Αντικαταστάτες',
    'Ο Άνθρωπος του Νοέμβρη',
    'Η Μεγάλη Ληστεία',
    '3 Μέρες Διορία',
    'Νυχτερινή καταδίωξη',
    'Η Αρπαχτή',
    'Το βλέμμα του δράκου',
    'Ο Πολλαπλός Εαυτός Μου',
    'Μυστική Πράκτορας',
    'Το Ξίφος του Δράκου',
    'Χαμένοι στον Ήλιο',
    'Σκοπευτής ειδικών δυνάμεων',
    'Μάχη με το χρόνο',
    'Ποιός κλέβει ποιόν;',
    '6 τρόποι για να πεθάνεις',
    'Οι εξολοθρευτές',
    'Ο Φυγάς',
    'Βηρυτός',
    'Ο Κόμης Μόντε Κρίστο',
    'Απόδραση από το Αλκατράζ',
    'Όταν Ξέσπασε η Βία',
    'Η παρείσφρηση',
    'Στον δρόμο της εκδίκησης',
    'Ο Σκοτεινός Ιππότης: Η Επιστροφή',
    'Παγκόσμιος Πόλεμος Ζ',
    'Κύματα Φωτιάς 2',
    'Στην Κόψη του Κύματος',
    'Εκτός Ελέγχου',
    'Γαλαζιος Κεραυνός',
    'Το Στοίχημα Του Σλέβιν',
    'Η Ληστεία της Μαφίας',
    'Τετάρτη 04:45',
    'Χαϊλάντερ 2: Η Επιστροφή',
    'Νικίτα',
    'Κομάντο',
    'Ο Μπάτμαν Επιστρέφει',
    'Ο Δρόμος της Επιστροφής',
    'ΜΑΘΗΜΑΤΑ ΑΥΤΟΑΜΥΝΑΣ',
    'Η δύναμη της πίστης',
    'Ζωή σε φιλμ',
    'Αναχώρηση για Παρίσι 15:17',
    'Ρουά Μάτ',
    'Διπλό παιχνίδι',
    'Ο Λαβύρινθος της σιωπής',
    'Γλυκιά ανάμνηση',
    'Η αιώνια ζωή της Μάρτζορι',
    'Το τελευταίο χτύπημα',
    'Ώρες αγωνίας',
    '2046',
    'Βαλές Κούπα',
    'Κηλίδες που Δεν Εσβησε ο Χρόνος',
    'Καμίλ Κλωντέλ',
    'Σιντ και Νάνσυ',
    'Ο Υποψήφιος',
    'Ο Νονός: Η Αναβίωση του Κόπολα Τριλογία',
    'Μια πόλη δίπλα στη θάλασσα',
    'Φρανκ και Λόλα',
    'Γλυκό Φασόλι',
    'Άλπεις',
    'Τα Δύο Πρόσωπα Του Έρωτα',
    'Νερούδα',
    'Το Πράσινο Μίλι',
    'Χωρίς φραγμούς',
    'Ανεξιχνίαστη Ληστεία',
    'Εξαιρετικά Δυνατά & Απίστευτα Κοντά',
    'Το Τέλος μιας Σχέσης',
    'Το Παρελθόν της Ούνα',
    'Ποιος Μου Χτυπά Την Πόρτα;',
    'Το θαύμα των Χριστουγέννων',
    'Ο Άνθρωπος με τα Χίλια Πρόσωπα',
    'Ο Πεταλούδας',
    'Κρυφή Ομορφιά',
    '300',
    'Τζέικομπ ο Ψεύτης',
    'Εγχειρίδιο Αναγνώρισης Αγίων',
    'Η Αποστολή',
    'Τες',
    'Ενα Πλοίο για την Παλαιστίνη',
    'Η Κόρη του Ράιαν',
    'Πειρατές της Καραϊβικής - Η Κατάρα του Μαύρου Μαργαριταριού',
    'Απόδραση στον Αέρα',
    'Τζέιμς Μποντ Πράκτωρ 007: Από τη Ρωσία με Αγάπη',
    'Οι Περιπέτειες του Σέρλοκ Χολμς',
    '13',
    'Η μέρα της επιστροφής μου',
    'Τζέιμς Μποντ: Ο Ανθρωπος με το Χρυσό Πιστόλι',
    'Τζέιμς Μποντ, Πράκτωρ 007: Επιχείρηση Μουνρέικερ',
    'Δύο Σκληροί Ατσίδες',
    'Οι Θησαυροί του Σολομώντα',
    'Η Κοιλάδα της Βίας',
    'Απόδραση από το Λος Άντζελες',
    'Καλλίπολη 1915',
    'Ψυχρό αίμα',
    'Ουρανοξύστης',
    'Μόνο ο Θεός Συγχωρεί',
    'Ο Πεζοναύτης',
    'Υπόθεση Τόμας Κράουν',
    'Τζέιμς Μποντ Πράκτωρ 007 - Προσωπική Εκδίκηση',
    'Οικογένεια Άνταμς',
    'Χοντρός και Λιγνός',
    'Τρελες Σφαιρες 2 1/2',
    'Η Πρόταση',
    'Αμελί',
    'Τρελά πλούσιοι',
    'Η Συμμορία των 8',
    'Στα Πρόθυρα νευρικής κρίσης',
    'Οι Ταχυδακτυλουργοί',
    'Αγρυπνος στο Σιάτλ',
    'Διακοπές Με Τον Μπαμπά μου',
    'Αγαπη Ειναι',
    'Τέσσερις Γάμοι και μια Κηδεία',
    'Διαβολογυναίκα',
    'Η Χάνα και οι Αδελφές Της',
    'Οι Λευκοι Δεν Μπορουν Να Πηδηξουν',
    'Πέρα απ\' την Κοιλάδα με τις Κούκλες',
    'Άτακτος Παππούς',
    'Ηλεκτρονικό Μανούλι',
    'Ερωτευμένος με τη γυναίκα μου',
    'Γούντι ο Τρυποκάρυδος: Η Ταινία',
    'Ματίλντα',
    'Τα Παιδιά της Χορωδίας',
    'Μόλις αρχίσαμε',
    'Ο Ερωτας του Φεγγαριού',
    'Πόκεμον Ντετέκτιβ Πίκατσου',
    'Έχετε Μήνυμα στον Υπολογιστή σας',
    'Μικρά Όμορφα Πλάσματα',
    'Με τον Μπαμπά ή τη Μαμά; 2',
    'Κάθε μέρα... μαζί!',
    'Οι Νύχτες του Χάρλεμ',
    'Ο Καουμπόυ του Μεσονυχτίου',
    'Ο Αστακός',
    'Το Σύνδρομο της Κίνας',
    'Το Κουρδιστό Πορτοκάλι',
    'Καλημέρα Βιετνάμ (Ειδική Έκδοση)',
    'Χωρίς Μέτρο',
    'Μάκβεθ',
    'Φίλες εξ\' αίματος',
    'Οικογενειακός φίλος',
    'Ουράνια έκπληξη',
    'Βρώμικο Σαββατοκύριακο',
    'Ο πρώτος άνθρωπος',
    'Η κατηγορούμενη',
    'Μόνο οι Εραστές Μένουν Ζωντανοί',
    'Βερολίνο σ\' αγαπώ',
    'Η εξομολόγηση της δασκάλας του πιάνου',
    'Διαγραφή Ταυτότητας',
    'Το κορίτσι με το μαργαριταρένιο σκουλαρίκι',
    'Αγάπη',
    'Η γέννηση ενός έθνους',
    'Χαμένοι στη Μετάφραση',
    'Ηλεκτρικά Ονειρα',
    'Χωρίς Αντάλλαγμα',
    'Χάρι Πότερ: Η Ολοκληρωμένη Συλλογή 8-Ταινιών',
    'Ο Χάρι Πότερ Και Η Φιλοσοφική Λίθος',
    'Εκδικητές 4: Η Τελευταία Πράξη',
    'Ο Πέρσι Τζάκσον και οι Ολύμπιοι: Η Κλοπή της Αστραπής',
    'Κυνηγός',
    'Η Μούμια',
    'Ο Άρχοντας Των Δαχτυλιδιών: Η Συλλογή',
    'Ο Πλανήτης των Πιθήκων: Η Σύγκρουση',
    'Οι Εκδικητές',
    'Ο Σκοτεινός Ιππότης - Η Επιστροφή',
    'Εκδικητές: Ο Πόλεμος της Αιωνιότητας',
    'Γούλβεριν',
    'Ο Καρυοθραύστης και τα Τέσσερα Βασίλεια',
    'Το Καταραμένο Σκιάχτρο',
    'Ξόρκισε το Κακό',
    'Στοιχειωμένο Ασυλο',
    'Μούσα',
    'Παγιδευμένη ψυχή 4: το τελευταίο κλειδί',
    'Μόνοι στο σπίτι',
    'Ένοπλη απάντηση',
    'Αντέχεις να Δεις;',
    'Το Αυτό',
    'Βαθιά άγρια θάλασσα',
    'Μην ανοίξεις',
    'Τα Σημάδια του Δράκουλα',
    'Το σπίτι που έχτισε ο Τζακ',
    'Ο Κύριος Αρκάντιν',
    'Ταξίδι στο βυθό της θάλασσας',
    'Ο Ψαλιδοχέρης',
    'Το Ημερολόγιο ενός Σπασίκλα: Θα Πάει Μακριά η Βαλίτσα;',
    'Ποιός παγίδευσε τον Ρότζερ Ράμπιτ',
    'Στα Μαχαίρια',
    'Οι Περιπέτειες μιας Μπέιμπι Σίτερ',
    'Το Ημερολόγιο Ενός Σπασίκλα - Νέοι Κανόνες',
    'Οι Άντρες Προτιμούν τις Ξανθιές',
    'Το Ημερολόγιο Ενός Σπασίκλα 3: Σκυλίσια Ζωή',
    'Ο Μικρός Αρειανός',
    'Ο Μικρός Νικόλας Πάει Διακοπές',
    'Ο Κατάδικος του έρωτα',
    'Ισορροπίες Ζωής',
    'Χόλυγουντ: Η Πόλη Των Ευκαιριών',
    'Τα Πάντα Γύρω Από Το Σεξ',
    'Το Ημερολόγιο μιας Πριγκίπισσας',
    'Το Μωρό της Μπρίτζετ Τζόουνς',
    'Αστερίξ Η Κατοικία Των Θεών',
    'Ληστεία... Σκέτη Τραγωδία',
    'Ταλέντο Για Μεγάλα Κόλπα',
    'Κηπουρός για Κλάματα',
    'Τα Παιχνίδια Της Αγάπης',
    'Μάρλεϊ - Ένας Μεγάλος Μπελάς',
    'Μανχάταν',
    'Όταν ο Χάρι Γνώρισε τη Σάλι',
    'Οικογένεια Τενενμπάουμ',
    'Ο Πιπίλας',
    'Άλλη Γεύση',
    'Μια Γαλλίδα Στο Μανχάταν',
    'Ενώ εσύ κοιμόσουν',
    'Ο Αρχάριος',
    'Το Πανδοχείο της 6ης Ευτυχίας',
    'Γλυκιά Ζωή',
    'Γερτρούδη',
    'Ο Αστυνόμος',
    'Η Διάσωση',
    'Τοπίο Ολέθρου',
    'Φανταστικά ζώα και πού βρίσκονται',
    'Ο Καρυοθραύστης',
    'Το Χρονικό της Νάρνια - Ο Ταξιδιώτης της Αυγής',
    'Ο Πρίγκιπας της Περσίας',
    'Φύλακες του Γαλαξία',
    'Ομάδα Αυτοκτονίας',
    'Ανθρωπος από Ατσάλι',
    'Ντάμπο',
    'Ο λαβύρινθος',
    'Πολίτης Κέην',
    'Οι Δέκα Εντολές',
    'Ταξίδι στο Τόκιο',
    'ΜΟΝΟ ΟΙ ΑΓΓΕΛΟΙ ΕΧΟΥΝ ΦΤΕΡΑ',
    'Συνέβη Μια Νύχτα',
    'Θάνατος στη Βενετία',
    'Για Ποιον Χτυπά η Καμπάνα',
    'Στη Σκιά των Τεσσάρων Γιγάντων',
    'Το Λιμάνι της Αγωνίας',
    'Θάνατος Στο Νείλο',
    'Ο Κλέφτης της Βαγδάτης',
    'Ναυτική Ανταρσία',
    'Οι Αταίριαστοι',
    'Ο Σκοτεινός Ιππότης',
    'Φύλακες του Γαλαξία 2',
    'Η καρδιά του δράκου: μάχη για την πηγή της φωτιάς',
    'Μπλέηντ Ράνερ: Ομάδες Εξόντωσης',
    'Τα Μυστικά του Δάσους',
    'Παν',
    'Οζ: Μέγας και Παντοδύναμος',
    '2001 Η Οδύσσεια Του Διαστήματος: Ειδική Έκδοση',
    'Η Χώρα του αύριο',
    'Η Παραλία',
    'Τζέιμς Μποντ Πράκτωρ 007: Για τα Μάτια σου Μόνο',
    'Ανίερη Συμμαχία',
    'Σχέδιο Πτήσης',
    'Το Μούτρο',
    'Η Νύχτα των Ηλιοτροπίων',
    'Στην Καρδιά της Θάλασσας',
    'Η Απαγωγή του Κου Χάινεκεν',
    'Νυχτερινό Απόσπασμα',
    'Το Νησί του Φόβου',
    'Σύμμαχοι',
    'Ανάσταση',
    'Εντιμότατοι κλέφτες',
    'Ζεις Μόνο Μια Φορά',
    'Ο Χορός Των Νεκρών',
    'Επικίνδυνη Αποστολή 3',
    'Μάχη για το Στέμμα',
    'Ερασιτέχνης Ζιγκολό',
    'Φτιάχνοντας τον Τέλειο Εραστή',
    'Το Μούτρο του Μπέβερλι Χιλς',
    'Μάρμαντιουκ',
    'Το Κορίτσι των Ονείρων μου',
    'Επάγγελμα Νεκροθάφτης',
    'Ληστεία σε…30’',
    'Η Μάρθα Συναντάει τον Φρανκ, τον Ντάνιελ & τον Λώρενς',
    'Έτοιμες για όλα',
    'Ποτέ Δεν Είναι Αργά',
    'Η Μηχανή της Χαράς',
    'Το Κυνήγι της Επιτυχίας και πώς να τα',
    'Άντρες με τα Όλα τους',
    'Εκδίκηση για τον Τζόλι',
    'Ιδανικός Γάμος',
    'Η Συνταγή της Πωλέτ',
    'Η Αδερφή της Αδερφής σου',
    'Φούντα Εξπρές',
    'Η Ολοκαίνουργια Καινή Διαθήκη',
    'Φθηνές Ανατριχίλες',
    'Σε ξένα παπούτσια',
    'Ο Νεράιδος',
    'Ή το ποδόσφαιρο ή εγώ',
    'ΣΥΓΝΩΜΗ ΓΙΑ ΤΗΝ ΕΝΟΧΛΗΣΗ',
    'Τα Πουλιά',
    'Μπάτσελορ στη Βουδαπέστη',
    'Χάουαρντ ο Αχτύπητος',
    'Μεθυδμένοι και απένταροι',
    'Μια Υπέροχη Ζωή Μετά Θάνατον',
    'Η Μάγκι έχει σχέδιο',
    'Επιθυμίες... στο Παρά Πέντε',
    'Λίγο πριν το γάμο',
    'Οι Ξεδιάντροποι',
    'ΔΙΑΚΟΠΕΣ ΣΤΗΝ ΒΕΝΕΤΙΑ',
    'Μπότες, Σπιρούνια και Καυτές Σέλες',
    'Ένας πιστός άνδρας',
    'Η Απατηλή Λάμψη της Ματαιοδοξίας',
    'Φίλα με!',
    'Τρελό Θηριοτροφείο: Η Νέα Γενιά',
    'ο Ημερολόγιο Μιας Πριγκίπισσας 2 - Βασιλικοί Αρραβώνες',
    'Ταξίδι στο Μαϊάμι',
    'Τα Λέμε στο Διάλειμμα',
    'Οι Κολλητοί',
    'Ο Μάικ, ο Ντέιβ και οι ξέφρενες φιλενάδες',
    'Κατά Λάθος Φάντασμα',
    'Σκυλιά του πολέμου',
    'Κατά Λάθος Έρωτας',
    'Τίτλοι Τέλους',
    'Γιατρός στο χωριό',
    'Τα Συνεταιράκια',
    'Καν\' το όπως οι άλλες',
    'Χριστουγεννιάτικη Ευχή',
    'Πριγκίπισσα των Παπαράτσι: Η Ιστορία της Πάρις Χίλτον',
    'Παντρεύτηκα έναν βλάκα',
    'Ο Θαυματοποιός',
    'Χωρίς παιδιά',
    'Φοβού τον Πεθερό',
    'Πολύ Χοντρός Ψεύτης 2',
    'Ο Μεγάλος Λεμπόφσκι',
    'ΝΙΚΟΣΤΡΑΤΟΣ - ΕΝΑ ΞΕΧΩΡΙΣΤΟ ΚΑΛΟΚΑΙΡΙ',
    'Οι Περιπετειες Της Πρισιλα Της Βασιλισσας Της Ερημου',
    'Οι Ρομαντικοί',
    'Ο Εισβολέας',
    'Το Σπίτι στο Τέλος του Δρόμου',
    'Ο Θησαυρός του βουνού',
    'Θάρρος ή αλήθεια',
    'Ο Όρκος',
    'Κωδικός Κολιμπρί',
    'Ο γάμος της πρώην μου',
    'Κακός Σαμαρείτης',
    'ΘΑΝΑΤΟΣ ΣΤΟ ΧΙΟΝΙ',
    'Κινγκ: Μία Ιστορία Εκδίκησης',
    'Ερωτική Πλεκτάνη',
    'Δύο Αδέλφια, οι Γυναίκες τους και μια Ερωμένη',
    'Το Νησί της Αποπλάνησης',
    'Χωρίς Λόγια',
    'Πιάστε τον Κοντό',
    'Η Μέρα Της Μαρμότας',
    'Το μπαρμπέρικο: Η νέα κουπ',
    'Ο Αϊ Βασίλης είναι πολλή λέρα',
    'Ταξί στην Τεχεράνη',
    'Ένας Προφήτης, μα τι Προφήτης',
    'Τώρα Δεν Μας Σταματάει Τίποτα',
    'Μία Τελευταία Φορά',
    'Στάρσκι & Χατς',
    'Μερικοί το Προτιμούν Καυτό',
    'Πρακτοράτζα',
    'Παλεύοντας με την οικογένειά μου',
    'Η Επιστροφή Του Ροζ Πάνθηρα',
    'Λαγωνικό Κ-9',
    'Η θετική πλευρά της ζωής',
    'Ο Έρωτας Κρατάει 3 Χρόνια',
    'Ο Άγιος Βασίλης Μου 3',
    'Χειρότερα δεν γίνεται',
    'Το Τραγούδι Της Καρδιάς Μου',
    'Αμερική Τέλος!',
    'Δαγκωμένος από Έρωτα',
    'Ο Αϊ-Βασίλης ειναι Λέρα',
    'Παρθένος Ξανά',
    'Ο Σταθμός',
    'Γαμπρός Για Κλάματα!',
    'Στην Χώρα Των Άλλων',
    'Με μια ψυχή',
    'Ολέθρια Σύγκρουση',
    'Φαίδρα',
    'Ευαίσθητες Χορδές',
    'Συνέβη στη Γαλλία',
    'Ένα βήμα τη φορά',
    'Επαναστάτης στη Σίκαλη',
    'Στα Βαθιά',
    'Ο Ευεργέτης',
    '400 μίλια αγάπης',
    'Αν η οδός Μπιλ μπορούσε να μιλήσει',
    'Οικογενειακή Γιορτή',
    'Κάλπικο άλμπουμ',
    'Γκοντάρ, αγάπη μου',
    'Κράτα Ενα Φως Αναμμένο',
    'Στο περιθώριο',
    'Ο Πρόεδρος',
    'Μετά την καταιγίδα',
    'Ξεχασμένος στο διάστημα',
    'Η ΔΕΥΤΕΡΗ ΑΛΗΘΕΙΑ',
    'Η επιστροφή του Μπεν',
    'Οι Άνδρες με τα Μαύρα 3',
    'Καυτή Καταδίωξη',
    'Μάθε Μαμά μου Σερφ',
    'Μπροϋνο',
    'Η Μαφία σκοτώνει μόνο το καλοκαίρι',
    'Ηλίθιος και ο Πανηλίθιος Δίο',
    'Η Τζένι παντρεύεται',
    'Το Μερίδιο των Αγγέλων',
    'Ημερολόγιο Διακοπών',
    'Γιορτή της Μητέρας',
    'Οικογενειακές Ανισορροπίες',
    'Ταξίδι στην Ιταλία',
    'Όλοι οι καλοί χωράνε',
    'Αγαπώντας Πίνοντας και Τραγουδώντας',
    'Δυο τρελοι παραγωγοι',
    'Η Τέλεια Ομορφιά',
    'Πώς να κάνετε έρωτα σαν Εγγλέζος',
    'Γερόλυκοι',
    'Παρά Λίγο Γάμος',
    'Μεγάλα Κορίτσια',
    'Ο Γάμος του Καλύτερού μου Φίλου',
    'Λόγια και Εικόνες',
    'Μια Απαράδεκτη Κωμωδία',
    'Να Ζήσουμε να τον Θυμόμαστε',
    'Επικίνδυνη Οικογένεια',
    'Ελεύθερη Συμβίωση',
    'Μεσάνυχτα στο Παρίσι',
    'Χτυποκάρδια στο Γραφείο',
    'Αφεντικά για Σκότωμα 2',
    'Θα σε κάνω Άντρα',
    'Αστυνομος Σαινης',
    'Γκόστμπαστερς 2',
    'Το Δόλωμα',
    'Οι Πονηρές Μπίζνες Ενός Πρωτάρη',
    'Νυχτερινό σχολείο',
    'Γράμματα στην Ιουλιέτα',
    'Βασιλιάς για μια Νύχτα',
    'Ζευγάρι με το ζόρι',
    'Κάποτε στην Καλιφόρνια',
    'Μουσικοί Δεσμοί',
    'Κυρία από τύχη',
    'Ας νικήσει η καλύτερη',
    'Σαλό, 120 Μέρες στα Σόδομα',
    'Ιστορίες αγάπης',
    'Το Ντεμπούτο',
    'Συντονιστείτε Στην Αλήθεια',
    'Το Ξαδερφάκι μου Ο Βίνι',
    'Κοριτσι Για Φιλημα',
    'Ρόντι: Ο Σούπερσταρ της Ασφάλτου',
    'Ο Σωφέρ της Κας Νταίζυ',
    'Μια Πράσινη Ιστορία',
    'Ποτέ Δεν Είσαι Μόνος',
    'Καλπάζοντας Μόνος Χιλιάδες Μίλια',
    'Τζακ & Ρόουζ: Μπαλάντα για Δύο',
    'Παράδεισος της Πίστης',
    'Μελβούρνη',
    'Καθημερινοί ήρωες',
    'Οι Αθλιοι',
    'Το μυστικό της πεταλούδας',
    'Ηλιόλουστος Έρωτας',
    'Ακριβώς το Τέλος του Κόσμου',
    'Η Καινούργια Φιλενάδα',
    'Σχέση 5 με 7',
    'Ο Αντρας που Καίγεται',
    'Αγαπημένη',
    'Ο Ηλίθιος',
    'Η Μαύρη Καλλονή',
    'Ασανσέρ για 2',
    '99 Σπίτια',
    'Ελεύθερος Σκοπευτής',
    'Το Μαύρο Άλογο',
    'Φινέας και Φέρμπ – Χριστούγεννα με τον Πέρρυ',
    'Χριστούγεννα Κάθε Μέρα',
    'Άκατα Μάκατα - Τα Ζουζούνια παρουσιάζουν τα Χριστούγεννα',
    'Τα Φιλαράκια του Αη Βασίλη',
    'Το αστέρι των Χριστουγέννων',
    'Μαμάδες με Κακή Διαγωγή: Χριστούγεννα Εκτός Ελέγχου',
    'ΕΛΛΙΟΤ Ο ΠΙΟ ΜΙΚΡΟΣ ΤΑΡΑΝΔΟΣ',
    'Οι Πειρατές Της Καραϊβικής: Σε Άγνωστα Νερά',
    'Ρόκι',
    'Τζέιμς Μποντ Πράκτωρ 007: Ζεις Μονάχα Δύο Φορές',
    'Οι Ύποπτοι Φορούσαν Γόβες',
    'Οι Πειρατές Της Καραϊβικής 3: Στο Τέλος Του Κόσμου',
    'Οι Πειρατές Της Καραϊβικής 2: Το Σεντούκι Του Νεκρού',
    'Τζέιμς Μποντ, Πράκτωρ 007: Ποτέ μην Ξαναπείς Ποτέ',
    'Θα Πληρωσετε',
    'Η Επιστροφή',
    'Ανοιχτοί Λογαριασμοί',
    'Πολύ Σκληρός για να Πεθάνει: Η Εκδίκηση',
    'Στα Ίχνη Του Χαμένου Θησαυρού',
    'Στα Ίχνη Του Χαμένου Θησαυρού: Το Βιβλίο Με Τα Μυστικά',
    'Τον Ήθελαν Νεκρό',
    '24 Ώρες Προθεσμία',
    'Τζέιμς Μποντ Πράκτωρ 007: Επιχείρηση Οκτοπούσι',
    'Μόμπι Ντικ',
    'Πολύ Σκληρός για να Πεθάνει',
    'Αδίστακτα Πρόσωπα',
    'Ουασινγκτον Στοχος Των Τρομοκρατων',
    'Μαύρος Θάνατος',
    'Δραπέτης Της Κολάσεως',
    'Η Μελωδία της Ευτυχίας',
    'Τα Μαγικά Χριστούγεννα του Μίκυ',
    'Η Πεντάμορφη & το Τέρας – Τα Μαγεμένα Χριστούγεννα',
    'Πάρτι φαντασμάτων',
    'Χριστουγεννιάτικα Κάλαντα',
    'Χριστουγεννιάτικη Ιστορία',
    'Μόνος στο Σπίτι 4',
    'Γουίνι το Αρκουδάκι: Χαρούμενες Στιγμές',
    'Μίκυ Μια Φορά και Έναν Καιρό',
    'Μόνος στο Σπίτι 3',
    'Τα Χριστουγεννιάτικα Κάλαντα του Μίκυ',
    'Μια Φορά και Δύο Καιρούς Ήταν τα Χριστούγεννα του Μίκυ',
    'Αναζητώντας τη Χώρα του Χειμώνα',
    'Γουίνι το Αρκουδάκι: Οι Εποχές των Δώρων',
    'Το Πολικό Εξπρές',
    'Η Λέσχη του Μίκυ - Ο Μίκυ σώζει τον Αϊ Βασίλη',
    'Ο Μαστοράκος: Δουλευταρούδικες Διακοπές',
    'ΧΡΙΣΤΟΥΓΕΝΝΙΑΤΙΚΑ ΦΙΛΑΡΑΚΙΑ: Ο ΘΡΥΛΟΣ ΤΟΥ ΑΓ. ΓΑΒΣΙΛΗ',
    'Ο Άγιος Βασιλής μου',
    'Χριστουγεννιάτικη Μπαλάντα',
    'Τα Καλά Σκυλάκια Τραγουδούν τα Κάλαντα',
    '\'Αη Βασίλης Τζούνιορ',
    'Οι φόνοι της οικογένειας Μπόρντεν',
    'Ο Πρίγκιπας Των Μυγών',
    'Αγάπη & Σεβασμός',
    'Ο Άνεμος Χορεύει Το Κριθάρι',
    'Κάθε χίλια χρόνια',
    'Λίνκολν',
    'Οι Μάγισσες του Σάλεμ',
    'Ο Άνθρωπος Που Δεν Ήταν Εκεί',
    'Γεννημένος Χορευτής',
    'Το Κορίτσι των Γενεθλίων',
    'Οδηγός Επιτυχίας',
    'Χορεύοντας Με Τους Λύκους',
    'Μέχρι Τέλους',
    'Γράμμα από το παρελθόν',
    'Ο δικός της πόλεμος',
    'Ο Καιρός Των Ινδιάνων',
    'Ερωτικά παιχνίδια',
    'Σεζάν και Ζολά',
    'Ο Πατριάρχης',
    'Ενας Ησυχος Ανθρωπος',
    'Η Μαγική Ομπρέλα',
    'Τα Καλύτερα Έρχονται',
    'Ο Ανδρας που Αγαπήθηκε Πολύ',
    'Οργισμένος εκδικητής',
    'Η Τελευταία Πινελιά',
    'Στον Έρωτα και στον Πόλεμο',
    'Οι Ζωές Των Άλλων',
    'Ριψοκίνδυνοι Άνδρες',
    'Σκοτεινό αμάρτημα',
    'Ο Προδότης',
    'Ζωή',
    'Όλα τα λεφτά του κόσμου',
    'Ανεκπλήρωτος Γάμος',
    'Μανταρίνια',
    'Δόκτωρ Ζιβάγκο',
    '12 Χρόνια Σκλάβος',
    'Το μόνο που είχαμε',
    'Ιούδας',
    'Οι Φυλακισμένες',
    'Η Δασκάλα μας',
    'Η Περίπτωση του Οιδίποδα',
    'Ασθενής μηδέν',
    'Σε απόγνωση',
    'Το Μυστικό της Ευτυχίας',
    'Βίαιη δικαιοσύνη',
    'Το Παιχνίδι του Χρήματος',
    'Περιοχή υψηλού κινδύνου',
    'Με Σειρά Εξαφάνισης',
    'Οι μπάσταρδοι του πολέμου',
    'Η τελευταία ληστεία',
    'Όμηροι στη Θάλασσα',
    'Ματωμένο Χρήμα',
    'Σκιά',
    'Αποστολή στη Χιλή',
    'Χελς Κίτσεν: Οι Βασίλισσες του εγκλήματος',
    'Εκδίκηση σε δεύτερο χρόνο',
    'Ο τυχοδιώκτης του Παρισιού',
    'ΕΥΤΥΧΙΑ',
    'ΠΟΛΙΟΡΚΙΑ',
    'Σαπουνόπετρα',
    'ΓΙΑ ΠΑΝΤΑ',
    'Ένας Άλλος Κόσμος',
    'Γυναίκες Δηλητήριο',
    'Ο τελευταίος παρτιζάνος',
    'Περιμένοντας τη νονά',
    'Ο Βιοπαλαιστής στη στέγη',
    'Το Χαμένο Σήμα της Δημοκρατίας',
    'Φαντασία',
    'Ματζουράνα',
    'Στρελλα',
    'Κυνόδοντας',
    'Κινέττα',
    'Ο Θησαυρός',
    'Κρήτη Νο.1',
    'Πελοπόννησος Νο.1',
    'Βήματα Αποστ. Παύλου',
    'Θάσος',
    'Ρόδος Νο.1',
    'Μακεδονία Νο.2',
    'Θησαυροί της Ρωσίας',
    'Ισθμός',
    'Μετέωρα Νο.1',
    'Η Επίθεση του γιγαντιαίου μουσακά',
    'Μαραθώνιος μιας Ημιτελούς Ανοιξης: Γρηγόρης Λαμπράκης',
    'Ελλήνων Έργα: Σινεμά - Το Ελληνικό Φανταστικό Σινεμά',
    'Τα Παιδία δεν Παίζει',
    'Συγχαρητήρια στους Αισιόδοξους?',
    'Η Αιώνια Επιστροφή του Αντώνη Παρασκευά',
    'Ελλάδα Νο.1',
    'Ο Βυσσινόκηπος',
    'Η Λιμουζίνα',
    'Ρ20 - Μπορείς Ξανά',
    'Βαλκανιζατέρ',
    'Νορβηγία',
    'Σ\' αυτή τη χώρα κανείς δεν ήξερε να κλαίει',
    'Ο Μαγικός Καθρέφτης',
    'Η Ρόζα της Σμύρνης',
    'Προσευχήσου πριν πεθάνεις',
    'Καπταιν Χουκ',
    'Σε Θέση Βολής',
    'Αρχικατάσκοπος',
    'Επίλεκτος Πράκτορας',
    'Όλοι πρέπει να πεθάνουν',
    'Η συμμορία του τυφώνα',
    'Ομάδα Υποβρύχιων Καταστροφών',
    'Κυνήγι Ανθρώπων',
    'Λεωφορείο 657',
    'Η ληστεία του αιώνα',
    'Αμέρικαν Νίντζα',
    'Φωτιά στις Κάνες μας',
    'Ο Ανθρωπος από τη Γαλλία',
    'Ο Σωματοφύλακας του Εκτελεστή',
    'Έρωτας στη Σιβηρία',
    'Ζήτημα εμπιστοσύνης',
    'Η Ληστεία',
    'Το κόλπο της Σαγκάης',
    'Η Πτώση της Αμερικανικής Αυτοκρατορίας',
    'Το κορίτσι στον ιστό της αράχνης',
    'Βατικανό: Απόρρητοι φάκελοι',
    'Η Κατάρα του Ντάουνερς Γκρόουβ',
    'Το Σκηνικό του Τρόμου',
    'Νύχτα Θύελλας',
    'Ο Εξορκιστής',
    'Συνέντευξη με Ένα Βρικόλακα',
    'Σφαγείο',
    'Φωνές μέσα από τους τοίχους',
    'Τα Σαγόνια του Καρχαρία 3',
    'Δόκτωρ Τζέκιλ και Κύριος Χάιντ',
    'Πορφυρός Λόφος',
    'Απόλυτος Τρόμος',
    'Το απόλυτο κενό',
    'Νύχτα Τρόμου 2',
    'Ο Σχιζοφρενής Δολοφόνος με το Πριόνι 2',
    'Παγιδευμένη',
    'Παρασκευή Και 13',
    'Το Πεπρωμένο της Τζούπιτερ',
    'Στενές Επαφές Τρίτου Τύπου',
    'Φανταστικά ζώα: Τα εγκλήματα του Γκρίντελβαλντ',
    'Ο Εξολοθρευτής',
    'Ταξιδιώτης στον Χρόνο',
    'Ο Λαβυρινθος Του Πανα',
    'Φανταστική Καταδίωξη',
    'Η συμμορία των μάγων 2',
    'Ο Τσάρλι Και Το Εργοστάσιο Σοκολάτας',
    'Στρατιώτες του Σύμπαντος: Προδοσία στον Άρη',
    'Το Ιερό Ξίφος',
    'Εφτά στον παράδεισο',
    'Ζουν Ανάμεσα μας',
    'Νοσφεράτου, μια Συμφωνία Τρόμου',
    'Εμείς',
    'Πενήντα Αποχρώσεις του Γκρι: Απελευθέρωση',
    'Πενήντα Πιο Σκοτεινές Αποχρώσεις του Γκρι',
    'Εμμανουέλλα',
    'Σαλον Κιττυ',
    'Οι Μαγισσες Του Ιστγουικ',
    'Σκανδαλα Στα Θρανια',
    'Η Τζούλιετ, Γυμνή',
    'Τυφλό σημείο',
    'Όλα Αρχίζουν Αύριο',
    'Για Όνομα του Θεού!',
    'Σφυρίζοντας για τον Ερωτα',
    'Γεια Χαρά!',
    '3 Γάμοι σ`ένα μήνα',
    'Ιστορίες για άγριους',
    'Θα έρθω κοντά σου σιγά σιγά',
    'Αγάπη και Τιμή',
    'Μια δεύτερη ευκαιρία',
    'Οδηγός Οικογενειακής Επιβίωσης',
    'Γκαστόν, ο γκαφατζής',
    'Χαμός στη Βραζιλία',
    'Νεκρός Κατά Λάθος',
    'Μαμά από το πουθενά',
    'Έτσι είναι η ζωή',
    'Βάλε τη γιαγιά στο ψυγείο',
    'Η Κακή Μέρα από το Πρωί Φαίνεται',
    'Το μυστικό τους',
    'Διχασμένο Κορμί',
    'Τα σαγόνια της Γης: Μια παγωμένη μέρα στην κόλαση',
    'Ο Στοιχειωμένος Πύργος',
    'Σήμα Κινδύνου 2',
    'Το Μάτι Της Γάτας',
    'Φρέσκο Αίμα',
    'Νεκροταφείο Ζωντανών 2',
    'Αιματηρό Ανθρωποκυνηγητό',
    'Η ιστορία της αγάπης',
    'Η Μαχαιριά',
    'Στον αστερισμό του Διδύμου',
    'Εδώ και τώρα',
    'Τι θα πει ο κόσμος',
    'Αδάμαστο πνεύμα',
    'Σοκ και δέος',
    'Ο Θεριστής',
    'Ο Γλάρος',
    'Πόλεμος ναρκωτικών',
    'Πριν φύγεις',
    'Η ιστορία ενός τρελού',
    'Η μαθητευόμενη',
    'Οι Φύλακες',
    'Ένα Ενωμένο Βασίλειο',
    'Η Μυστική Γραφή',
    'Σουζάνα με σκοτώνεις',
    'Ντιν',
    'Καλή Σύζυγος',
    'Η Γυναίκα με τη Μερσεντές',
    'Ο κόκκινος σκύλος: ένας πιστός φίλος',
    'Ο Ήρωας',
    'Επικίνδυνη Συμμορία',
    'Όλα για Σένα',
    'Τα Παιδικα Χρονια του Ιβαν',
    'Η Θυσία',
    'Ρώμη, Ανοχύρωτη Πόλη',
    'Καλοκαιρινά Παιχνίδια',
    'Ολα για τη Μητέρα μου',
    'Ερωτες Χωρίς Φραγμό',
    'Δεσμοί Αίματος',
    'Χωρίς Μάρτυρες',
    'Φόνος Στο Όριεντ Εξπρές',
    'Οι Τέσσερις Καβαλάρηδες Της Αποκάλυψης',
    'Μαύρα Γυαλιά',
    'Ανήλικος Δολοφόνος',
    'Παρενέργειες',
    'Ανεξέλεγκτες Καταστάσεις',
    'Ποτέ Δεν Είσαι Μόνη',
    'Συνήθεις Ύποπτοι',
    'Κακή Τύχη',
    'Βασικό Ένστικτο',
    'Αναζητώντας τη Δικαιοσύνη',
    'ΣΤΟ ΣΤΟΜΑ ΤΩΝ ΛΥΚΩΝ',
    'Ο Πιλότος Του Καρτέλ',
    'Οι Χήρες',
    'Το Ασυλο του Τρόμου',
    'Έγκλημα τον Νοέμβρη',
    'Η Ξαδέρφη μου η Ρέιτσελ',
    'Ψυχώ',
    'Άγρια Όνειρα',
    'Απόλυτα Ξένοι',
    'Η καταδίωξη',
    'Το Καλεσμα',
    'Πλατούν',
    'Η Μεγαλύτερη Ημέρα του Πολέμου',
    'Η Γέφυρα του Ρεμάγκεν',
    'Στις Άμμους της Ιβοζίμα',
    'Τα Κανόνια Του Ναβαρόνε',
    '1917',
    'Γαλλική Σουίτα',
    'Τα Πράσινα Μπερέ',
    'Μακριά από τους Ανθρώπους',
    'Με φόβο',
    'Ο Επίλεκτος',
    'Σύρριζα: Ο Νόμος της Επιστροφής',
    'Η Γέφυρα του Ποταμού Κβάι',
    'Και οι δώδεκα ήταν καθάρματα',
    'Απόβαση στη Νορμανδία - Η Αντίστροφη Μέτρηση',
    'Μέρες θυμού',
    'Παιδιά στα όπλα',
    'Αόρατος Εχθρός',
    'Ναρκοπέδιο',
    'Έρωτας στα Χρόνια του Πολέμου',
    'Η Αυγή της Απόδρασης',
    'Αποστολή στη Χαμένη Ήπειρο',
    'Το Τέρας του Βάλτου',
    'Ορφέας και Ευρυδίκη',
    'Το βράδυ που έφαγε τον κόσμο',
    'Χαμόγελα Καλοκαιρινής Νύχτας',
    'Καλοκαίρι με την Μόνικα',
    'Ο Άνθρωπος Με Τα Δύο Πρόσωπα',
    'Αντίχριστος',
    'Τρία Χρώματα: Η Λευκή Ταινία',
    'Μια Καλή Χρονιά',
    'Η Ωραία Της Ημέρας',
    'Οι Θρύλοι του Καντέρμπουρι',
    'Ο Καταδικασμένος',
    'Πουλημένη απ` τη Μητέρα της',
    'Ζούσε τη Ζωή της',
    'Ο Δαίμων της 11ης Ωρας',
    '8 ½',
    'Ο Λόγος',
    'Μαζί ή τίποτα',
    '360',
    'Πειρατεία στον Ωκεανό',
    'Χορωδία',
    'Φιτζκαραλντο',
    'Ο Ταξιτζής',
    'Μια Σχέση Στοργής',
    'Αποστροφή',
    'Δουνκέρκη',
    'Αποδημητικά Πουλιά',
    'Καζανόβα Τελευταία Αγάπη',
    'Οι Πειρατές της Σομαλίας',
    'Το Εισιτήριο',
    'Το Ημερολόγιο του Χένρι',
    'Πού χάθηκες, Μπερναντέτ;',
    'Δύο βήματα μακριά',
    'Ξέγνοιαστος Καβαλάρης',
    'Σεξ, Ψέμματα και Βιντεοταινίες',
    'Η Συναντηση Μιας Νυχτας',
    'Μιναρέδες Στη Νέα Υόρκη',
    'Ήσυχες Μέρες',
    'Αγώνας θανάτου',
    'Η Χήρα',
    'Δαμασκός: Εμπιστευτικό',
    'Ο εξαφανισμένος φάκελος',
    'Μην φύγεις',
    'Βασικός ύποπτος',
    'Το Μικρό Νησί',
    'Το Μυστικό των Μάρομποουν',
    'Ημερολόγιο Φόνων',
    'Η Βοηθός',
    'Σλουθ (1972)',
    'Η λίστα των διεφθαρμένων',
    'Θανάσιμη Εκδίκηση',
    'Αόρατη Ζωή',
    'Κι ο Κλήρος πέφτει στον Σμαίλι',
    'Αραχνοφοβία',
    'Το Κορίτσι που Εξαφανίστηκε',
    'Απέραντη Οργή',
    'Με Διπλή Ταυτότητα',
    'Φράντικ',
    'Εκδίκηση',
    'Το Λάθος Θύμα',
    'Ο ΛΙΠΟΤΑΚΤΗΣ',
    'Η Ξένη',
    'Η Αγχόνη',
    'Λύκοι ανάμεσα μας',
    'Δωμάτιο Πανικού',
    'Μην αφήσεις ίχνος',
    'Η Βασίλισσα της Ισπανίας',
    'Ανακαλύπτοντας την Αλταμίρα',
    'Σκοτεινό Παρελθόν',
    'Εντμόντ: Ένας Απρόβλεπτος Συγγραφέας',
    'ΠΟΝΟΣ ΚΑΙ ΔΟΞΑ',
    'Ο Σύμβουλος',
    'Χαριέτ',
    'Κρατικά Μυστικά',
    'ΟΙΚΟΓΕΝΕΙΑΚΗ ΕΥΤΥΧΙΑ',
    'Λέσχη Νέων Δισεκατομμυριούχων',
    'ΑΓΩΝΑΣ ΓΙΑ ΔΙΚΑΙΟΣΥΝΗ',
    'Η Πιό Σκοτεινή Ωρα',
    'Η ΜΠΑΛΑΝΤΑ ΤΟΥ ΡΙΤΣΑΡΝΤ ΤΖΟΥΕΛ',
    'Σχέσεις Πάθους',
    'Ο Βασιλιάς μου',
    'Γράψε λάθος',
    'Στο Καταφύγιο της Καρδιάς',
    'Αχτίδα Ελπίδας',
    'Στο Κενό Της',
    'ΜΕΣΟΚΑΛΟΚΑΙΡΟ',
    'Θεία Δίκη',
    'Νεκροταφείο Ζωντανών',
    'Η Κατάρα της Γιορόνα',
    'Οι Αγροίκοι',
    'Τρέξε!',
    'Γενέθλια Θανάτου 2',
    '28 Μέρες Μετά',
    '28 Εβδομάδες Μετά',
    'Μη Σβήσεις Το Φως',
    'Το Κάλεσμα 2',
    'Η νύχτα με τις μάσκες',
    'Φάρσα Θανάτου',
    'Η Επιστροφή του Τσάκι',
    'Η Καλόγρια',
    'Η Νυχτα Με Τις Μασκες',
    'Γενέθλια Θανάτου',
    'Διχασμένος',
    'Παρασκευή και 13 Μέρος 7: Η Ανατριχίλα',
    'ΣΤΙΓΜΑΤΑ',
    'Το λουκανόσκυλο',
    'Το μυστήριο του κυρίου Πικ',
    'Αριζόνα',
    'Σπίτι μου Σπιτάκι μας',
    'Η Ρίκι και η Ροκ',
    'Τερματικός Σταθμός',
    'Κοκομπλόκο',
    'Το Ξεκαθάρισμα 2019',
    'Η ψυχή του πάρτι',
    'Μαμάδες με κακή διαγωγή',
    'Ένα σπίτι στο Παρίσι',
    'Δέκα μέρες χωρίς τη μαμά',
    'Ο Καλύτερος Φίλος μου',
    'Γιατρέ μου, κερατωθήκαμε',
    'Σέρλοκ Χολμς & Δρ Γουάτσον',
    'Οιδιπόδειο Αλα Γαλλικά',
    'Κολλητοί Με Παιδί',
    'Πουθενά χωρίς την κόρη μου',
    'Ομάδα ΓΑΒ',
    'Ο ρυθμός της καρδιάς',
    'Ξαναβρίσκοντας τη Μαγεία',
    'Δεν Είναι για τα Μούτρα Σου',
    'Ανασφάλειες Ζωής',
    'Αμπρακαταμπρα',
    'Σε μια αυλή στο Παρίσι',
    'Ταξίδι στην Ισπανία',
    'Νυν και πρώην',
    'Η Λιακάδα Μέσα μου',
    'Σαββατοκύριακο με τα Κορίτσια',
    'Μπάσταρδοι',
    'Ο Χάσελχοφ πρέπει να πεθάνει',
    'Δολοφόνος με το ζόρι',
    'Εκδίκηση με Στυλ',
    'Μάντεψε ποιος ήρθε για τα γενέθλια σου',
    'Πάρτι διαζυγίου',
    'Μια Νύχτα στον Κόσμο',
    'Ω Αδελφέ, Πού Είσαι;',
    'Επιχείρηση: Καζίνο',
    'Καλώς ήρθατε στο Μάργουεν',
    'Χαλαρώστε Κύριε Αλέν! (2018)',
    'Ξυπόλητοι στο Παρίσι',
    'Μπαμπάς εν δράσει',
    'Κηδεία είναι, θα περάσει',
    'Ένα φανταστικό σπίτι',
    'Όλα από την αρχή',
    'Καλά Αγόρια',
    'ΟΔΗΓΟΣ ΓΙΑ ΕΓΚΛΗΜΑΤΙΕΣ',
    'Επάγγελμα: Παλαμάκιας',
    'Ο Παραλίας',
    'Επτά Μέρες Φαγούρα, Τροπική Καταιγίδα, Ο Άρχοντας Της Πασαρέλας',
    'Με Λένε ακόμα Τρινιτά',
    'Ψαρεύοντας Σολομούς στην Υεμένη',
    'Σατρύκον Φελλίνι',
    'Ρόμα',
    'Μέσα από τον Σπασμένο Καθρέφτη',
    'Σανζούρο',
    'Η Εβδομη Σφραγίδα',
    'Ο Ήλιος είναι ένα Αστέρι',
    'Ο Καθρέφτης',
    'Η Σκόνη Του Χρόνου',
    'Καφές και Τσιγάρα',
    'Ραντεβού με ένα Αστέρι',
    'Το Δεκαήμερο',
    'Ψεύτης Ήλιος',
    'Το σουτιέν',
    'Φθινοπωρινή Σονάτα',
    'Ένας Αμερικανός Φίλος',
    'Νοσταλγία',
    'Μ - Ο Δράκος του Ντίσελντορφ',
    'Η Μεγάλη Χίμαιρα',
    'Αίμα Και Πάθος',
    'Δράκουλας',
    'Κάρι, Εκρηξη Οργής',
    'Τα Παιδιά της Νύχτας',
    'Το νησί του τρόμου',
    'Ο Σαμ ήταν εδώ',
    'Η τρύπα',
    'Το Κυνήγι',
    'Το οικοτροφείο',
    'Μα',
    'Η Συνεχεια Της Παρανοιας',
    'Η Αυτοψία',
    'Το σπίτι της φρίκης',
    'Κρύψου',
    'Ο Εξορκισμός Της \'Εμιλυ Ρόουζ',
    'Το κορίτσι της εκδίκησης'
  ].sort(() => (Math.random() > 0.5 ? -1 : 1)),
  EN: [
    '*batteries not included',
    '...No Lies',
    '1 - Nenokkadine',
    '101 Dalmatians',
    '102 Dalmatians',
    '12 Angry Men',
    '12 Years a Slave',
    '13 Assassins',
    '13 Tzameti',
    '13: Game of Death',
    '20,000 Leagues Under the Sea',
    '22 Jump Street',
    '28 Days Later',
    '3 Men and a Baby',
    '3:10 to Yuma',
    '500 Days of Summer',
    '7 Grandmasters',
    'A Beautiful Mind',
    'A Bittersweet Life',
    'A Bridge Too Far',
    'A Bronx Tale',
    'A Bug\'s Life',
    'A Christmas Carol',
    'A Christmas Story',
    'A Cinderella Story',
    'A Clockwork Orange',
    'A Dog\'s Life',
    'A Dog\'s Purpose',
    'A Few Good Men',
    'A Fistful of Dollars',
    'A Fistful of Dynamite',
    'A Goofy Movie',
    'A Handful of Clouds',
    'A Man Called Ove',
    'A Night at the Opera',
    'A Patch of Blue',
    'A Prophet',
    'A Quiet Place',
    'A Quiet Place Part II',
    'A Separation',
    'A Series of Unfortunate Events',
    'A Serious Man',
    'A Silent Voice',
    'A Special Day',
    'A Star Is Born',
    'A Wednesday',
    'A Wrinkle in Time',
    'Abominable',
    'About Time',
    'Ace Ventura: Pet Detective',
    'Ace in the Hole',
    'Adam\'s Rib',
    'After Hours',
    'Agent Cody Banks',
    'Aguirre, Wrath of God',
    'Airplane!',
    'Alexander and the Terrible, Horrible, No Good, Very Bad Day',
    'Alice Through the Looking Glass',
    'Alice in Wonderland',
    'All About the Benjamins',
    'All Dogs Go to Heaven',
    'All Quiet on the Western Front',
    'All That Jazz',
    'All the President\'s Men',
    'Almost Famous',
    'Alvin and the Chipmunks',
    'Alvin and the Chipmunks: Chipwrecked',
    'Alvin and the Chipmunks: The Squeakquel',
    'American Beauty',
    'American History X',
    'American Hustle',
    'American Pie',
    'American Psycho',
    'American Splendor',
    'An American Tail',
    'An Andalusian Dog',
    'An Unfinished Life',
    'Analyze This',
    'Anastasia',
    'Anatomy of a Murder',
    'Andaz Apna Apna',
    'Andhadhun',
    'Andrei Rublev',
    'Angels in the Outfield',
    'Angels with Dirty Faces',
    'Animal Crackers',
    'Annie Hall',
    'Anonymous',
    'Apocalypse Now',
    'Apocalypto',
    'Apollo 13',
    'Aquamarine',
    'Are We There Yet?',
    'Around the World in 80 Days',
    'Arthur Christmas',
    'Arthur and the Invisibles',
    'Article 15',
    'As Good as It Gets',
    'Assault on Precinct 13',
    'Asterix &amp; Obelix: Mission Cleopatra',
    'Asterix and Obelix Take on Caesar',
    'Asterix at the Olympic Games',
    'Astro Boy',
    'Atlantis: The Lost Empire',
    'Atonement',
    'Au Revoir les Enfants',
    'Austin Powers: The Spy Who Shagged Me',
    'Autumn Sonata',
    'Avengers Assemble',
    'Avengers: Endgame',
    'Avengers: Infinity War',
    'Awakenings',
    'Baahubali 2: The Conclusion',
    'Babe: Pig in the City',
    'Baby Driver',
    'Baby Geniuses',
    'Baby\'s Day Out',
    'Back to the Future',
    'Back to the Future Part II',
    'Back to the Future Part III',
    'Barry Lyndon',
    'Barton Fink',
    'Batman Begins',
    'Batman: Mask of the Phantasm',
    'Batman: The Movie',
    'Battle Royale',
    'Beat Street',
    'Beauty and the Beast',
    'Bedknobs and Broomsticks',
    'Bedtime Stories',
    'Bee Movie',
    'Beethoven',
    'Beethoven\'s 2nd',
    'Before Midnight',
    'Before Sunrise',
    'Before Sunset',
    'Being John Malkovich',
    'Best Shot',
    'Bethlehem',
    'Better Off Dead...',
    'Beverly Hills Cop',
    'Beverly Hills Cop II',
    'Bhaag Milkha Bhaag',
    'Bicycle Thieves',
    'Big Fat Liar',
    'Big Hero 6',
    'Billy Elliot',
    'Binta and the Great Idea',
    'Birthday Girl',
    'Black Dynamite',
    'Black Swan',
    'Blade Runner',
    'Blade Runner 2049',
    'Blazing Saddles',
    'Blood Diamond',
    'Blood In, Blood Out',
    'Blue Is the Warmest Colour',
    'Bob le Flambeur',
    'Bohemian Rhapsody',
    'Boiler Room',
    'Bonnie and Clyde',
    'Boyz n the Hood',
    'Braveheart',
    'Breathless',
    'Bride of Frankenstein',
    'Bridge to Terabithia',
    'Brief Encounter',
    'Bringing Up Baby',
    'Brokeback Mountain',
    'Brother Bear',
    'Brotherhood',
    'Brothers in Arms',
    'Bud Abbott Lou Costello Meet Frankenstein',
    'Buffalo \'66',
    'Bullets or Ballots',
    'Burn After Reading',
    'Butch Cassidy and the Sundance Kid',
    'Butterflies',
    'Caddyshack',
    'Call Me by Your Name',
    'Cape Fear',
    'Captain America: Civil War',
    'Captain America: The Winter Soldier',
    'Captain Phillips',
    'Captain Underpants: The First Epic Movie',
    'Cartel Land',
    'Casablanca',
    'Casino Royale',
    'Cast Away',
    'Catch Me If You Can',
    'Cats &amp; Dogs',
    'Chak De! India',
    'Charlie and the Chocolate Factory',
    'Charlotte\'s Web',
    'Chasing Amy',
    'Cheaper by the Dozen',
    'Cheaper by the Dozen 2',
    'Chhichhore',
    'Chicken Little',
    'Chicken Run',
    'Children of Heaven',
    'Children of Men',
    'Chinatown',
    'Chitty Chitty Bang Bang',
    'Chris Rock: Bigger &amp; Blacker',
    'Christmas with the Kranks',
    'Chungking Express',
    'Cinderella',
    'Cinderella Man',
    'Cinema Paradiso',
    'Citizen Kane',
    'City Island',
    'City Lights',
    'City Slickers',
    'City of Ember',
    'City of God',
    'City of Men',
    'Clash of the Titans',
    'Cloudy with a Chance of Meatballs',
    'Cloudy with a Chance of Meatballs 2',
    'Cloverfield',
    'Coach Carter',
    'Combat de boxe',
    'Come and See',
    'Coming to America',
    'Confessions of a Teenage Drama Queen',
    'Cool Hand Luke',
    'Cool Runnings',
    'Cowboy Bebop: The Movie',
    'Crouching Tiger, Hidden Dragon',
    'Curse of the Golden Flower',
    'D2: The Mighty Ducks',
    'D3: The Mighty Ducks',
    'Daddy Day Care',
    'Daddy\'s Home',
    'Dallas Buyers Club',
    'Dancer in the Dark',
    'Dances with Wolves',
    'Dara of Jasenovac',
    'Darkness/Light/Darkness',
    'Dawn of the Dead',
    'Dawn of the Planet of the Apes',
    'Days of Heaven',
    'Dead Snow',
    'Deadpool 2',
    'Deception',
    'Delhi Belly',
    'Demon Slayer the Movie: Mugen Train',
    'Dennis the Menace',
    'Departures',
    'Design for Living',
    'Despicable Me 3',
    'Detroit Rock City',
    'Diary of a Wimpy Kid',
    'Diary of a Wimpy Kid 2: Rodrick Rules',
    'Dickson Experimental Sound Film',
    'Die Hard: With a Vengeance',
    'Dil Chahta Hai',
    'Dilwale Dulhania Le Jayenge',
    'Dirty Harry',
    'Dirty Rotten Scoundrels',
    'Django Unchained',
    'Doctor Dolittle',
    'Doctor Strange',
    'Doctor Zhivago',
    'Dog Day Afternoon',
    'Donnie Brasco',
    'Donnie Darko',
    'Dora and the Lost City of Gold',
    'Double Indemnity',
    'Down by Law',
    'Dr. Dolittle 2',
    'Dr. Strangelove or: How I Learned to Stop Worrying and Love the Bomb',
    'Dragon Ball Z: Battle of Gods',
    'Drishyam 2',
    'Driving Miss Daisy',
    'Drunken Master',
    'Duck Soup',
    'DuckTales the Movie: Treasure of the Lost Lamp',
    'Dumb and Dumber',
    'Eastern Promises',
    'Eddie Murphy: Delirious',
    'Eddie Murphy: Raw',
    'Eddie the Eagle',
    'Edge of Tomorrow',
    'Edward Scissorhands',
    'El Camino: A Breaking Bad Movie',
    'El Dorado',
    'Elite Squad',
    'Elite Squad 2: The Enemy Within',
    'Ella Enchanted',
    'Empire of the Sun',
    'Enchanted',
    'End of Watch',
    'Enemy at the Gates',
    'Enter The Dragon',
    'Enter the Void',
    'Escape from Alcatraz',
    'Eternal Sunshine of the Spotless Mind',
    'Evan Almighty',
    'Evil Dead II',
    'Eyes Without a Face',
    'Fail-Safe',
    'Fallen Angels',
    'Falling Down',
    'Fantasia 2000',
    'Fantastic Beasts: The Crimes of Grindelwald',
    'Fantastic Mr. Fox',
    'Farewell My Concubine',
    'Fast Times at Ridgemont High',
    'Father of a Soldier',
    'Father of the Bride',
    'Father of the Bride Part II',
    'Fear and Loathing in Las Vegas',
    'Fear(s) of the Dark',
    'Federico Fellini\'s 8½',
    'Ferdinand',
    'FernGully: The Last Rainforest',
    'Ferris Bueller\'s Day Off',
    'Fiddler on the Roof',
    'Field of Dreams',
    'Fight Club',
    'Fill the Void',
    'Final Fantasy VII: Advent Children',
    'Finding Nemo',
    'Fires on the Plain',
    'First Blood',
    'Five Graves to Cairo',
    'Flight of the Navigator',
    'Flushed Away',
    'For a Few Dollars More',
    'For the Birds',
    'Forbidden Planet',
    'Forrest Gump',
    'Four Lions',
    'Frankenstein',
    'Frankenweenie',
    'Freaky Friday',
    'Fred Claus',
    'Free Willy',
    'Fresh Guacamole',
    'Full Metal Jacket',
    'Game of Death',
    'Gangs of New York',
    'Gangs of Wasseypur',
    'Gangster Squad',
    'Garfield 2',
    'George of the Jungle',
    'Geri\'s Game',
    'Ghost Dog: The Way of the Samurai',
    'Ghost in the Shell',
    'Ghost in the Shell 2: Innocence',
    'Ghostbusters',
    'Gladiator',
    'Glengarry Glen Ross',
    'Gnomeo &amp; Juliet',
    'God Grew Tired of Us: The Story of Lost Boys of Sudan',
    'God\'s Own Country',
    'Goldfinger',
    'Gone Girl',
    'Gone with the Wind',
    'Good Burger',
    'Good Bye Lenin!',
    'Good Morning, Vietnam',
    'Good Will Hunting',
    'Goodbye Christopher Robin',
    'Goodfellas',
    'Goosebumps',
    'Gran Torino',
    'Grand Prix',
    'Grave of the Fireflies',
    'Green Book',
    'Green Street',
    'Greener Grass',
    'Grindhouse',
    'Grosse Pointe Blank',
    'Groundhog Day',
    'Guardians of the Galaxy',
    'Guardians of the Galaxy: Vol. 2',
    'Guess Who\'s Coming to Dinner',
    'Gulliver\'s Travels',
    'Gully Boy',
    'Hababam Sinifi',
    'Hachi: A Dog\'s Tale',
    'Hacksaw Ridge',
    'Half Baked',
    'Halloween',
    'Hannah Montana: The Movie',
    'Happy Feet',
    'Happy Feet Two',
    'Hard Boiled',
    'Harold &amp; Kumar Get the Munchies',
    'Harold and Maude',
    'Harry Potter and the Deathly Hallows: Part 2',
    'Harry Potter and the Half-Blood Prince',
    'Harry Potter and the Order of the Phoenix',
    'Harry and the Hendersons',
    'Heaven Is for Real',
    'Heavyweights',
    'Hedwig and the Angry Inch',
    'Hell or High Water',
    'Hell\'s Angels',
    'Hera Pheri',
    'Herbie Fully Loaded',
    'High Noon',
    'High Plains Drifter',
    'High School Musical 3: Senior Year',
    'High and Low',
    'Hiroshima Mon Amour',
    'His Girl Friday',
    'Hit and Run',
    'Hocus Pocus',
    'Home Alone 2: Lost in New York',
    'Home Alone 3',
    'Homeward Bound: The Incredible Journey',
    'Honey, I Blew Up the Kid',
    'Honey, I Shrunk the Kids',
    'Hoodwinked',
    'Horton Hears a Who!',
    'Hotel Mumbai',
    'Hotel Rwanda',
    'Hotel Transylvania',
    'Hotel Transylvania 2',
    'Hotel Transylvania 3',
    'House of Flying Daggers',
    'How the Grinch Stole Christmas',
    'How to Train Your Dragon',
    'How to Train Your Dragon 2',
    'How to Train Your Dragon: The Hidden World',
    'Howl\'s Moving Castle',
    'I Am a Fugitive from a Chain Gang',
    'I Love You Phillip Morris',
    'I Saw the Devil',
    'Ice Age 2: The Meltdown',
    'Ice Age: Collision Course',
    'Ice Age: Continental Drift',
    'Ice Age: Dawn of the Dinosaurs',
    'Ice Princess',
    'Il Postino',
    'In Bruges',
    'In a Lonely Place',
    'In the Mood for Love',
    'In the Name of the Father',
    'Incendies',
    'Inception',
    'Indiana Jones and the Last Crusade',
    'Indiana Jones and the Temple of Doom',
    'Infernal Affairs',
    'Inglourious Basterds',
    'Inherit the Wind',
    'Inside Out',
    'Inspector Gadget',
    'Into the Wild',
    'Invasion of the Body Snatchers',
    'Iron Man 2',
    'Isle of Dogs',
    'It Happened One Night',
    'It\'s All Gone Pete Tong',
    'It\'s a Disaster',
    'It\'s a Mad Mad Mad Mad World',
    'It\'s a Wonderful Life',
    'Ivan\'s Childhood',
    'Jab We Met',
    'Jack Frost',
    'Jack the Giant Slayer',
    'Jackie Brown',
    'James And The Giant Peach',
    'Jeepers Creepers',
    'Jeremiah Johnson',
    'Jerry Maguire',
    'Jimmy Neutron: Boy Genius',
    'Jingle All The Way',
    'Jo Nesbø\'s Headhunters',
    'Jodhaa Akbar',
    'John Wick: Chapter 2',
    'John Wick: Chapter 3 - Parabellum',
    'Johnny Mad Dog',
    'Joint Security Area',
    'Journey 2: The Mysterious Island',
    'Journey to the Center of the Earth',
    'Joyeux Noel',
    'Judgment at Nuremberg',
    'Jules and Jim',
    'Jurassic Park',
    'Kagemusha',
    'Kai po che!',
    'Kal Ho Naa Ho',
    'Kangaroo Jack',
    'Kelly\'s Heroes',
    'Key Largo',
    'Kicking &amp; Screaming',
    'Kiki\'s Delivery Service',
    'Kill Bill: Vol. 1',
    'Kill Bill: Vol. 2',
    'Kind Hearts and Coronets',
    'King Kong',
    'Kingsman: The Secret Service',
    'Knockin\' on Heaven\'s Door',
    'Kubo and the Two Strings',
    'Kung Fu Hustle',
    'Kung Fu Panda',
    'Kung Fu Panda 2',
    'Kung Fu Panda 3',
    'L\'Avventura',
    'L\'ours, la femme et le chasseur',
    'L.A. Confidential',
    'La Grande Illusion',
    'La La Land',
    'La Vie En Rose',
    'Lady Killer',
    'Lady and the Tramp',
    'Lagaan: Once Upon a Time in India',
    'Lage Raho Munna Bhai',
    'Laputa: Castle in the Sky',
    'Last Man Standing',
    'Law Abiding Citizen',
    'Lawrence of Arabia',
    'Layer Cake',
    'Le Mans \'66',
    'Le Samouraï',
    'Lebanon: The Soldier\'s Journey',
    'Legend of the Guardians: The Owls of Ga\'Hoole',
    'Legends of the Fall',
    'Les Diaboliques',
    'Let Him Have It',
    'Let the Right One In',
    'Lethal Weapon',
    'Life Is Beautiful',
    'Like Stars on Earth',
    'Lilo &amp; Stitch',
    'Limitless',
    'Little Big Man',
    'Little Caesar',
    'Little Giants',
    'Little Women',
    'Lock, Stock and Two Smoking Barrels',
    'Lone Survivor',
    'Look Who\'s Talking Now',
    'Look Who\'s Talking Too',
    'Looney Tunes: Back in Action',
    'Lord of War',
    'Lost in Space',
    'Lost in Translation',
    'Loving Vincent',
    'Lucky Number Slevin',
    'Lust, Caution',
    'M.S. Dhoni: The Untold Story',
    'Mad Max 2',
    'Mad Max: Fury Road',
    'Madagascar',
    'Madagascar 3: Europe\'s Most Wanted',
    'Madagascar: Escape 2 Africa',
    'Major League',
    'Major Payne',
    'Maleficent',
    'Maleficent: Mistress of Evil',
    'Man Bites Dog',
    'Man on Fire',
    'Manchester by the Sea',
    'Manhattan',
    'Marley &amp; Me',
    'Marriage Story',
    'Mary Poppins Returns',
    'Mary and Max',
    'McFarland',
    'Mean Girls',
    'Mean Streets',
    'Meet Dave',
    'Meet the Robinsons',
    'Memories of Murder',
    'Mesrine Part 1: Killer Instinct',
    'Mesrine Part 2: Public Enemy Number 1',
    'Michael Kohlhaas',
    'Midnight Express',
    'Midnight Run',
    'Midnight in Paris',
    'Mighty Joe Young',
    'Mighty Morphin Power Rangers: The Movie',
    'Million Dollar Baby',
    'Minority Report',
    'Miracle on 34th Street',
    'Mirror Mirror',
    'Miss Peregrine\'s Home for Peculiar Children',
    'Mission: Impossible - Fallout',
    'Mister Roberts',
    'Modern Times',
    'Moneyball',
    'Monster House',
    'Monsters University',
    'Monsters vs. Aliens',
    'Monsters, Inc.',
    'Monte Carlo',
    'Monty Python and the Holy Grail',
    'Monty Python\'s Life of Brian',
    'Moonrise Kingdom',
    'Mr. Bean\'s Holiday',
    'Mr. Brooks',
    'Mr. Magorium\'s Wonder Emporium',
    'Mr. Nobody',
    'Mr. Peabody &amp; Sherman',
    'Mr. Popper\'s Penguins',
    'Mrs. Doubtfire',
    'Munna Bhai M.B.B.S.',
    'Muppets Most Wanted',
    'Murder in the First',
    'Mutiny on the Bounty',
    'My Cousin Vinny',
    'My Fair Lady',
    'My Father and My Son',
    'My Man Godfrey',
    'My Neighbour Totoro',
    'My Sassy Girl',
    'Nacho Libre',
    'Nanny McPhee',
    'Nanny McPhee and the Big Bang',
    'National Lampoon\'s Animal House',
    'National Lampoon\'s Vacation',
    'Nausicaä of the Valley of the Wind',
    'Neon Genesis Evangelion',
    'Neon Genesis Evangelion: The End of Evangelion',
    'News from the Good Lord',
    'Night at the Museum',
    'Night at the Museum 2',
    'Night at the Museum: Secret of the Tomb',
    'Night of the Living Dead',
    'Night on Earth',
    'Nightcrawler',
    'Nights of Cabiria',
    'Nim\'s Island',
    'Ninja Scroll',
    'No Country for Old Men',
    'North Face',
    'North by Northwest',
    'Nosferatu',
    'Notorious',
    'O Brother, Where Art Thou?',
    'OMG: Oh My God!',
    'OSS 117: Cairo, Nest of Spies',
    'Occupation: Dreamland',
    'Ocean\'s Eleven',
    'Of Mice and Men',
    'Office Space',
    'Old School',
    'Oliver &amp; Company',
    'On the Waterfront',
    'Once Upon a Time in America',
    'Once Upon a Time in the West',
    'One Flew Over the Cuckoo\'s Nest',
    'One of Those Days',
    'One, Two, Three',
    'Ong-Bak: The Thai Warrior',
    'Only God Forgives',
    'Only the Brave',
    'Open Range',
    'Open Season',
    'Osmosis Jones',
    'Out of the Past',
    'Over the Hedge',
    'Oz the Great and Powerful',
    'Paan Singh Tomar',
    'Paddington',
    'Paddington 2',
    'Pale Rider',
    'Pan\'s Labyrinth',
    'Paper Moon',
    'ParaNorman',
    'Parental Guidance',
    'Paths of Glory',
    'Paul Blart: Mall Cop',
    'Paul Blart: Mall Cop 2',
    'Peaceful Warrior',
    'Pee-wee\'s Big Adventure',
    'Peeping Tom',
    'Penguins of Madagascar',
    'Percy Jackson &amp; the Lightning Thief',
    'Percy Jackson: Sea of Monsters',
    'Perfect Blue',
    'Persepolis',
    'Pete\'s Dragon',
    'Peter Pan',
    'Peter Rabbit',
    'Pineapple Express',
    'Pink Flamingos',
    'Pink Floyd: The Wall',
    'Pirates of the Caribbean: The Curse of the Black Pearl',
    'Planet 51 (Planet One)',
    'Pocahontas',
    'Pokémon Detective Pikachu',
    'Pokémon: The First Movie',
    'Police Story',
    'Portrait of a Lady on Fire',
    'Predestination',
    'Pride &amp; Prejudice',
    'Primal Fear',
    'Princess Mononoke',
    'Prisoners',
    'Problem Child',
    'Pulp Fiction',
    'Puss in Boots',
    'Quiz Show',
    'R.V.: Runaway Vacation',
    'Raatchasan',
    'Race to Witch Mountain',
    'Racing Dreams',
    'Raging Bull',
    'Raiders of the Lost Ark',
    'Raise Your Voice',
    'Raise the Red Lantern',
    'Ralph Breaks the Internet',
    'Rang De Basanti',
    'Ratatouille',
    'Rear Window',
    'Red Cliff II',
    'Red River',
    'Remember the Titans',
    'Rendezvous',
    'Repulsion',
    'Requiem for a Dream',
    'Reservoir Dogs',
    'Return to Oz',
    'Revolutionary Road',
    'Rio Bravo',
    'Rise of the Planet of the Apes',
    'Ri¢hie Ri¢h',
    'Rob the Mob',
    'Rogue One',
    'Role Models',
    'Roman Holiday',
    'Rookie of the Year',
    'Rosemary\'s Baby',
    'Roundhay Garden Scene',
    'Run Lola Run',
    'Sansho Dayu',
    'Saving Private Ryan',
    'Scent of a Woman',
    'Schindler\'s List',
    'Scooby-Doo',
    'Scooby-Doo 2: Monsters Unleashed',
    'Scott Pilgrim vs. the World',
    'Seabiscuit',
    'Searching',
    'Searching for Bobby Fischer',
    'Secretariat',
    'See full summary',
    'Sense and Sensibility',
    'Seven Psychopaths',
    'Seven Samurai',
    'Shadow of a Doubt',
    'Shaolin Soccer',
    'Shark Tale',
    'Shaun of the Dead',
    'Sherlock Holmes',
    'Sherlock Holmes: A Game of Shadows',
    'Sherlock Jr.',
    'Shoot \'Em Up',
    'Short Circuit',
    'Short Term 12',
    'Shrek Forever After',
    'Shrek the Third',
    'Shutter Island',
    'Silver Linings Playbook',
    'Sinbad: Legend of the Seven Seas',
    'Sing Street',
    'Singin\' in the Rain',
    'Sister Act',
    'Sister Act 2: Back in the Habit',
    'Six Shooter',
    'Slap Shot',
    'Sleeping Beauty',
    'Slumdog Millionaire',
    'Small Soldiers',
    'Small Time Crooks',
    'Smallfoot',
    'Smart Money',
    'Smokin\' Aces',
    'Snoopy and Charlie Brown: The Peanuts Movie',
    'Snow Dogs',
    'Some Like It Hot',
    'Son of Rambow',
    'Son of the Mask',
    'Song of the Sea',
    'Soul Surfer',
    'Sound of Metal',
    'Source Code',
    'Space Jam',
    'Spaceballs',
    'Spartacus',
    'Special Chabbis',
    'Speed Racer',
    'Spellbound',
    'Spice World',
    'Spider-Man: Far from Home',
    'Spider-Man: Into the Spider-Verse',
    'Spies in Disguise',
    'Spirit: Stallion of the Cimarron',
    'Spirited Away',
    'Spotlight',
    'Spring, Summer, Autumn, Winter... and Spring',
    'Spy Kids 2: Island of Lost Dreams',
    'Spy Kids 3: Game Over',
    'Stagecoach',
    'Stalag 17',
    'Stan and Ollie',
    'Star Trek',
    'Star Trek II: The Wrath of Khan',
    'Star Trek into Darkness',
    'Star Trek: First Contact',
    'Star Wars: Episode III - Revenge of the Sith',
    'Star Wars: Episode IV - A New Hope',
    'Star Wars: Episode V - The Empire Strikes Back',
    'Star Wars: Episode VII - The Force Awakens',
    'Star Wars: Return of the Jedi',
    'Star Wars: The Clone Wars',
    'Still Walking',
    'Straight Outta Compton',
    'Stranger Than Fiction',
    'Strangers on a Train',
    'Straw Dogs',
    'Stuart Little',
    'Stuart Little 2',
    'Summer Wars',
    'Sunrise: A Song of Two Humans',
    'Sunset Blvd.',
    'Super Mario Bros.',
    'Superbabies: Baby Geniuses 2',
    'Surf\'s Up',
    'Suspicion',
    'Sweet Sixteen',
    'Sweet Smell of Success',
    'Synecdoche, New York',
    'Talk to Her',
    'Tangerines',
    'Tanghi argentini',
    'Taxi Driver',
    'Teenage Mutant Hero Turtles',
    'Teenage Mutant Ninja Turtles II: The Secret of the Ooze',
    'Teenage Mutant Ninja Turtles III',
    'Terminator 2: Judgment Day',
    'Thank You for Smoking',
    'The 2000 Year Old Man',
    'The 39 Steps',
    'The 400 Blows',
    'The Addams Family',
    'The Adventures of Robin Hood',
    'The Adventures of Sharkboy and Lavagirl 3-D',
    'The African Queen',
    'The Angry Birds Movie',
    'The Ant Bully',
    'The Apartment',
    'The AristoCats',
    'The Art of Racing in the Rain',
    'The Artist',
    'The Assassination of Jesse James by the Coward Robert Ford',
    'The Aviator',
    'The Ballad of Buster Scruggs',
    'The Bandit',
    'The Basketball Diaries',
    'The Battle of Algiers',
    'The Bellboy',
    'The Best Years of Our Lives',
    'The Big Blue',
    'The Big Lebowski',
    'The Big Shave',
    'The Big Sleep',
    'The Birds',
    'The Black Cauldron',
    'The Blair Witch Project',
    'The Blind Side',
    'The Blue Elephant',
    'The Blues Brothers',
    'The Boondock Saints',
    'The Boss Baby',
    'The Bourne Identity',
    'The Bourne Supremacy',
    'The Boxtrolls',
    'The Breakfast Club',
    'The Breath',
    'The Bridge on the River Kwai',
    'The Broken Circle Breakdown',
    'The Business',
    'The Cabinet of Dr. Caligari',
    'The Call of the Wild',
    'The Castle of Cagliostro',
    'The Cat Returns',
    'The Cat in the Hat',
    'The Celebration',
    'The Chaser',
    'The Chorus',
    'The Christmas Chronicles',
    'The Chronicles of Narnia: Prince Caspian',
    'The Chronicles of Narnia: The Lion, the Witch and the Wardrobe',
    'The Chronicles of Narnia: The Voyage of the Dawn Treader',
    'The Cincinnati Kid',
    'The Circus',
    'The Commitments',
    'The Conjuring',
    'The Count of Monte Cristo',
    'The Counterfeiters',
    'The Critic',
    'The Croods',
    'The Croods: A New Age',
    'The Curious Case of Benjamin Button',
    'The Damned United',
    'The Dark Crystal',
    'The Dark Hours',
    'The Dark Knight',
    'The Dark Knight Rises',
    'The Day the Earth Stood Still',
    'The Deer Hunter',
    'The Departed',
    'The Desperate Hours',
    'The Details',
    'The Dirty Dozen',
    'The Discreet Charm of the Bourgeoisie',
    'The Diving Bell and the Butterfly',
    'The Doors',
    'The Double Life of Véronique',
    'The Elephant Man',
    'The Emoji Movie',
    'The Enchanted Drawing',
    'The Errand Boy',
    'The Escapist',
    'The Exorcist',
    'The Exterminating Angel',
    'The Fast and the Furious: Tokyo Drift',
    'The Father',
    'The Fault in Our Stars',
    'The Fifth Element',
    'The Fighter',
    'The Flintstones',
    'The Football Factory',
    'The Founder',
    'The French Connection',
    'The Frisco Kid',
    'The Fugitive',
    'The Game Plan',
    'The General',
    'The Gentlemen',
    'The Girl Who Leapt Through Time',
    'The Godfather',
    'The Godfather: Part II',
    'The Gods Must Be Crazy',
    'The Gold Rush',
    'The Golden Compass',
    'The Good Dinosaur',
    'The Good the Bad the Weird',
    'The Good, the Bad and the Ugly',
    'The Goonies',
    'The Graduate',
    'The Grand Budapest Hotel',
    'The Great Dictator',
    'The Great Escape',
    'The Great Mouse Detective',
    'The Greatest Game Ever Played',
    'The Green Mile',
    'The Grinch',
    'The Guns of Navarone',
    'The Handmaiden',
    'The Hangover',
    'The Hateful Eight',
    'The Haunted Mansion',
    'The Hidden Fortress',
    'The Hobbit: An Unexpected Journey',
    'The Hobbit: The Desolation of Smaug',
    'The Holy Mountain',
    'The Honeymoon Killers',
    'The House with a Clock in Its Walls',
    'The Hunchback of Notre Dame',
    'The Hunger Games: Catching Fire',
    'The Hunt for Red October',
    'The Hurricane',
    'The Hustler',
    'The Imitation Game',
    'The Incredibles',
    'The Incredibles 2',
    'The Indian in the Cupboard',
    'The Informant!',
    'The Innocents',
    'The Invisible Guest',
    'The Invisible Man',
    'The Iron Giant',
    'The Karate Kid',
    'The Karate Kid Part II',
    'The Karate Kid Part III',
    'The Killer',
    'The Killing',
    'The King of Comedy',
    'The King\'s Speech',
    'The Krays',
    'The LEGO Movie 2',
    'The Lady Vanishes',
    'The Lady from Shanghai',
    'The Ladykillers',
    'The Last Airbender',
    'The Last King of Scotland',
    'The Last Picture Show',
    'The Last Samurai',
    'The Last of the Mohicans',
    'The Legend of 1900',
    'The Legend of Drunken Master',
    'The Lego Movie',
    'The Lighthouse',
    'The Lion King',
    'The Little Prince',
    'The Little Rascals',
    'The Lives of Others',
    'The Lizzie McGuire Movie',
    'The Longest Day',
    'The Longest Daycare',
    'The Look of Silence',
    'The Lorax',
    'The Lord of the Rings: The Fellowship of the Ring',
    'The Lord of the Rings: The Return of the King',
    'The Lord of the Rings: The Two Towers',
    'The Lost Weekend',
    'The Lunchbox',
    'The Magician',
    'The Magnificent Seven',
    'The Maltese Falcon',
    'The Man Who Knew Too Much',
    'The Man Who Shot Liberty Valance',
    'The Man Who Would Be King',
    'The Man from Nowhere',
    'The Manchurian Candidate',
    'The Matrix',
    'The Meaning of Life',
    'The Message',
    'The Mighty Ducks',
    'The Mitchells vs the Machines',
    'The Monster',
    'The Motorcycle Diaries',
    'The Mozart of Pickpockets',
    'The Muppets',
    'The Natural',
    'The Naughty Nineties',
    'The Negotiator',
    'The Next Karate Kid',
    'The Night of the Hunter',
    'The Nightmare Before Christmas',
    'The Notebook',
    'The Nut Job',
    'The Nutcracker and the Four Realms',
    'The Odd Couple',
    'The Odd Life of Timothy Green',
    'The One-Man Band',
    'The Others',
    'The Outlaw Josey Wales',
    'The Pacifier',
    'The Parent Trap',
    'The Passion of Joan of Arc',
    'The Perfect Man',
    'The Perfect Storm',
    'The Perks of Being a Wallflower',
    'The Philadelphia Story',
    'The Pianist',
    'The Piano',
    'The Pink Panther',
    'The Pink Panther 2',
    'The Pirates! In an Adventure with Scientists!',
    'The Place Beyond the Pines',
    'The Polar Express',
    'The Prestige',
    'The Prince &amp; Me',
    'The Prince of Egypt',
    'The Princess Bride',
    'The Princess Diaries',
    'The Princess Diaries 2',
    'The Princess and the Frog',
    'The Producers',
    'The Proposition',
    'The Public Enemy',
    'The Pursuit of Happyness',
    'The Queen of Versailles',
    'The Quiet Man',
    'The Raid 2',
    'The Red Balloon',
    'The Red Shoes',
    'The Red Violin',
    'The Remains of the Day',
    'The Rescuers',
    'The Rescuers Down Under',
    'The Revenant',
    'The Right Stuff',
    'The Road to El Dorado',
    'The Rocketeer',
    'The Rookie',
    'The Salvation',
    'The Sandlot Kids',
    'The Santa Clause',
    'The Santa Clause 2',
    'The Santa Clause 3: The Escape Clause',
    'The Saviour',
    'The Sea Inside',
    'The Searchers',
    'The Secret Life of Pets',
    'The Secret Life of Pets 2',
    'The Secret in Their Eyes',
    'The Seventh Seal',
    'The Shawshank Redemption',
    'The Shining',
    'The Shop Around the Corner',
    'The Silence of the Lambs',
    'The Simpsons Movie',
    'The Sixth Sense',
    'The Skin I Live In',
    'The Smurfs',
    'The Smurfs 2',
    'The Sorcerer\'s Apprentice',
    'The Sound of Music',
    'The Spiderwick Chronicles',
    'The SpongeBob Movie: Sponge Out of Water',
    'The SpongeBob SquarePants Movie',
    'The Spy Next Door',
    'The Sting',
    'The Straight Story',
    'The Substitute',
    'The Sword in the Stone',
    'The Taking of Pelham One Two Three',
    'The Tale of Despereaux',
    'The Tale of the Princess Kaguya',
    'The Ten Commandments',
    'The Terminal',
    'The Terminator',
    'The Theory of Everything',
    'The Thing',
    'The Third Man',
    'The Three Musketeers',
    'The Three Stooges',
    'The Transporter',
    'The Treasure of the Sierra Madre',
    'The Truman Show',
    'The Twilight Samurai',
    'The Usual Suspects',
    'The Wailing',
    'The War Game',
    'The Warriors',
    'The Water Horse',
    'The Wild Bunch',
    'The Wind Rises',
    'The Witches',
    'The Wizard of Oz',
    'The Wolf of Wall Street',
    'The World\'s Fastest Indian',
    'The Wrestler',
    'The Wrong Man',
    'There Will Be Blood',
    'This Is Spinal Tap',
    'Three Billboards Outside Ebbing, Missouri',
    'Three Burials',
    'Three Colours: Blue',
    'Three Colours: Red',
    'Three Kings',
    'Throne of Blood',
    'Time of the Gypsies',
    'Titan A.E.',
    'Titicut Follies',
    'To Be or Not to Be',
    'To Have and Have Not',
    'To Kill a Mockingbird',
    'To Rome with Love',
    'Tokyo Godfathers',
    'Tombstone',
    'Tomorrowland: A World Beyond',
    'Tooth Fairy',
    'Tora! Tora! Tora!',
    'Total Recall',
    'Touch of Evil',
    'Toy Story',
    'Toy Story 2',
    'Toy Story 3',
    'Toy Story 4',
    'Trading Places',
    'Train to Busan',
    'Training Day',
    'Trainspotting',
    'Transformation by Hats, Comic View',
    'Transformers',
    'Treasure Planet',
    'Trouble in Paradise',
    'True Grit',
    'True Romance',
    'Tucker and Dale vs Evil',
    'Twelve Monkeys',
    'Udta Punjab',
    'Umberto D.',
    'Underground',
    'Unforgiven',
    'United 93',
    'Untouchable',
    'Up in Smoke',
    'Uri: The Surgical Strike',
    'Vampire Hunter D: Bloodlust',
    'Vampires Suck',
    'Vantage Point',
    'Veer-Zaara',
    'Vicky Donor',
    'Videodrome'
  ].sort(() => (Math.random() > 0.5 ? -1 : 1))
};
